import { render, staticRenderFns } from "./recomendComF.vue?vue&type=template&id=1027dcf8&scoped=true"
import script from "./recomendComF.vue?vue&type=script&lang=js"
export * from "./recomendComF.vue?vue&type=script&lang=js"
import style0 from "./recomendComF.vue?vue&type=style&index=0&id=1027dcf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1027dcf8",
  null
  
)

export default component.exports